export const settingsKeys = {
  base: () => ["settings"],
  searchClients: (paramsString?: string, page?: number, perPage?: number) => {
    const key: (string | number)[] = [...settingsKeys.base(), "searchClients"];
    if (paramsString !== undefined) key.push(paramsString);
    if (page !== undefined) key.push(page);
    if (perPage !== undefined) key.push(perPage);
    return key;
  },
  searchAllClients: (paramsString: string) =>
    settingsKeys.searchClients(`all:${paramsString}`),
  clinicName: () => [...settingsKeys.base(), "clinicName"],
  dietitianAccount: () => [...settingsKeys.base(), "dietitianAccount"],
  clinicDietitiansSimpleList: () => [
    ...settingsKeys.base(),
    "clinicDietitiansSimpleList",
  ],
  clinicFacility: (id?: number) =>
    id !== undefined
      ? [...settingsKeys.base(), "clinicFacility", id]
      : [...settingsKeys.base(), "clinicFacility"],
  clinicFacilities: () => [...settingsKeys.base(), "clinicFacilities"],
  clinicCurrencies: () => [...settingsKeys.base(), "clinicCurrencies"],
  logRocketSettings: () => [...settingsKeys.base(), "logRocketSettings"],
  clinicDocuments: () => [...settingsKeys.base(), "clinicDocuments"],
};
